<div class="row open-selector" *ngIf="!activityService.bookingSection$.value">
    <div class="column col-lg-4">
        <div class="guest-edit-row">
            <div class="activity-booking__location col-lg-10 mt-5">
                <dynamic-form [config]="membershipConfig" #form="dynamicForm">
                </dynamic-form>
                <span class="membership-detail" *ngIf="hasMembershipValue && membershipValid">{{'MemberType'
                    |
                    translate}} :
                    {{activityService.selectedGuest?.MembershipType}}
                </span>
                <span class="custom-error"
                    *ngIf="hasMembershipValue && !membershipValid && !inputvalidation">{{'InvalidMembershipDetail'
                    | translate}}</span>
                <span class="custom-error"
                    *ngIf="hasMembershipValue && membershipValid">({{membershipStatus}})</span>
                <dynamic-form [config]="openBookingConfig" #form="dynamicForm">
                </dynamic-form>
                <div class="cover-size">
                    <div class="txt-sub-title">
                        {{'NoofStudents' | translate}}
                    </div>
                    <dynamic-form [config]="coverSizeConfig" #form="dynamicForm">
                    </dynamic-form>
                    <span class="custom-error" *ngIf="!validGroupSize">{{'MisMatchGroupSizeWithClass' | translate}}</span>
                </div>
                <!-- <div class="note">
                    {{'minimumsize' | translate}} ( <span> {{minSizeAllowed}} </span>)
                </div> -->
                <div class="booking-type" *ngIf="bookingTypeConfig && bookingTypeConfig.length">
                    <div class="txt-bold">
                        {{'SelectBookingTypes' | translate}}
                    </div>
                    
                        <dynamic-form [config]="bookingTypeConfig" #form="dynamicForm">
                        </dynamic-form>
                        <span class="custom-error" *ngIf="!validBookingTypes">{{'MisMatchBookingTypeWithBookingSize' |
                            translate}}</span>
                  
                </div>
                <div class="cover-type" *ngIf="coverTypeConfig && coverTypeConfig.length">
                    <div class="txt-bold">
                        {{'SelectCoverTypes' | translate}}
                    </div>
                    <dynamic-form [config]="coverTypeConfig" #form="dynamicForm">
                    </dynamic-form>
                    <span class="custom-error" *ngIf="!validCoverTypes">{{'MisMatchCoverTypeWithBookingSize' |
                        translate}}</span>
                </div>
            </div>
        </div>
        <div class="col-lg-6 col-md-6">
            <div class="reservation-timeslot__slots-list">
                <!-- Time Slots will eneterd here -->
            </div>
        </div>
    </div>
    <div class="open-slots-container col-lg-8">
        <ng-scrollbar>
        <div class="activity__banner-image" [ngClass]="{'layout__banner-image-height':activityService.hideImage}" *ngIf="!activityService.hideImage">
            <img src="{{activityService.imageUrl}}"  (error)="activityService.loadDefaultImage($event)" alt="banner-img" >
        </div>
        <div class="open-slot-container">
            <div class="no-slot" *ngIf="activityService.slots_holder && activityService.slots_holder.length === 0">
                {{'noslots' | translate}}
            </div>
            <div *ngIf="activityService.slots_holder && activityService.slots_holder.length">
                <div>{{'availableSlots' | translate}}</div>
                <app-open-booking-slot-view (SlotChanged)="checkFormValidity()" [isenableMultiple]="isMultipleEnabled" [allAvailableSlots]="availableSlots">
                </app-open-booking-slot-view>
            </div>
        </div>
        <div class="row button-container pre-next">
            <div class="button-group">

                <div class="d-inline-block button-gap">
                    <app-button [buttontype]="nextButton" (valueChange)="gotoNextPage($event)"></app-button>
                </div>
            </div>
        </div>
        </ng-scrollbar>
    </div>

</div>